import { Button, Form, Modal, Space, Typography } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';

const { Title } = Typography;

export default createGlobalStyle`
  .ant-modal-footer {
    border: none;
  }
`;

export const ContentModal = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

export const TextData = styled.text``;
export const TextTitle = styled(Title)`
    font-size: 16px !important;
    margin: 0 !important;
`;
export const ContentTitle = styled.div`
    padding: 17px 25px;
    border-bottom: 1px solid
        ${(props) =>
            props.theme.theme === 'light'
                ? '#ededed'
                : props.theme.colors.antdBorder};
`;
export const ContentFooter = styled.div``;
export const ContentStoreProduct = styled.div`
    height: 163px;
    border: 1px solid #dadada;
    border-radius: 2px;
    overflow: auto;
`;

export const BackgroundTransparent = styled.div`
    position: absolute;
    height: 60px;
    background: linear-gradient(
        180deg,
        ${(props) =>
            props.theme.theme === 'light'
                ? `rgba(255, 255, 255, 0) 0%, #fff 100%`
                : `
        rgba(31, 31, 31, 0) 0%,
        rgba(31, 31, 31, 0.4) 40%,
        #1f1f1f 100%
      `}
    );
    left: 0;
    right: 0;
    bottom: 0;
`;

export const AreaContent = styled.div`
    overflow: hidden;
    position: relative;
        padding: 0px 25px;
    margin-top: 12px;
    flex: 1;
    height: 100%;

    &::-webkit-scrollbar {
      display: none;
    }

    &::-ms-overflow-style: none;
    &::scrollbar-width: none;
`;

export const FormModal = styled(Form)`
    overflow: hidden;
    position: relative;
        padding: 0px 25px;
    margin-top: 12px;
    flex: 1;
    height: 100%;

    .ant-form-item-label > label{
        font-size: 16px;
        font-weight: 400;
    }

    &::-webkit-scrollbar {
      display: none;
    }

    &::-ms-overflow-style: none;
    &::scrollbar-width: none;
`;

export const CardContent = styled.div`
    text-align: justify;
    overflow: auto;
    position: relative;
    height: 100%;
    padding: 0px 0px 100px 0px;

    &::-webkit-scrollbar {
        display: none;
    }

    &::-ms-overflow-style: none;
    &::scrollbar-width: none;
`;

export const ButtonDelete = styled(Button).attrs({
    children: 'Excluir',
})`
    padding: 0 100px;
    position: absolute;
    left: 0px;
    top: 0px;

    @media only screen and (max-width: 850px) {
        position: relative;
    }
`;

export const ListStoresProducts = styled.ol`
    text-wrap: nowrap;
    padding: 12px 28px;
`;

export const ListStoreProduct = styled.li`
    list-style: none;
`;

export const FormItem = styled(Form.Item)`
    margin: 2px 0;
`;

export const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const BlockWrapper = styled.div`
    width: 45%;
`;

export const ButtonCancel = styled(Button).attrs({
    children: 'Cancelar',
    danger: true,
})`
    width: 227px;
`;

export const ButtonContinue = styled(Button).attrs({
    children: 'Continuar',
    type: 'primary',
    htmlType: 'submit',
})`
    width: 227px;
`;

export const SpaceButton = styled(Space)`
    display: flex;
    justify-content: center;
    gap: 29px !important;
    width: 100%;
`;

export const StyledModal = styled(Modal)<{ $singlePlanogram?: boolean }>`
    .ant-modal-container {
        padding: 0px;
    }
    .ant-modal-footer {
        z-index: 99999;
        position: relative;
        height: 55px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 0px 15px;
        border-top: ${(props) =>
            props.$singlePlanogram
                ? `1px solid ${
                      props.theme.theme === 'light'
                          ? '#ededed'
                          : props.theme.colors.antdBorder
                  }`
                : 'none'};
    }
    .ant-modal-content {
        overflow: hidden;
    }
`;

export const StepContainer = styled.div<{ active: boolean }>`
    height: 100%;
    display: ${(props) => (props.active ? 'block' : 'none')};
`;

export const FooterContent = styled.div`
    display: flex;
    justify-content: flex-end;
    position: relative;
    width: 100%;
`;

export const ReviewStep = styled.div`
    height: calc(80vh - 76px - 72px);
    overflow: hidden;
    display: flex;
    flex-direction: column;
`;

export const ConfirmBox = styled.div<{
    $disabled?: boolean;
}>`
    border: 1px solid
        ${(props) =>
            props.theme.theme === 'dark'
                ? props.theme.colors.antdBorder
                : '#d9d9d9'};
    border-radius: 8px;
    padding: 16px 12px;
    margin: 0;
    display: flex;
    align-items: flex-start;
    gap: 8px;
    background-color: ${(props) =>
        props.theme.theme === 'dark'
            ? props.theme.colors.antdBackground
            : '#fff'};
    cursor: pointer;
    user-select: none;
    flex-shrink: 0;

    ${(props) =>
        props.$disabled &&
        `
        cursor: not-allowed;
        opacity: 0.6;
        pointer-events: none;
        background: ${
            props.theme.theme === 'dark'
                ? props.theme.colors.antdBackground
                : '#f5f5f5'
        };
    `}

    &:hover {
        background-color: ${(props) =>
            props.theme.theme === 'dark' ? '#2a2a2a' : '#f0f0f0'};
    }

    &:active {
        background-color: ${(props) =>
            props.theme.theme === 'dark' ? '#2a2a2a' : '#f0f0f0'};
    }
`;

export const TextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: flex-start;
`;

export const MainText = styled.span`
    font-size: 14px;
    color: ${({ theme }) => (theme.theme === 'dark' ? '#fff' : '#262626')};
`;

export const SubText = styled.span`
    font-size: 14px;
    color: ${({ theme }) => (theme.theme === 'dark' ? '#fff' : '#8c8c8c')};
    font-weight: 400;
`;

export const FooterActions = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const FooterTopArea = styled.div`
    position: absolute;
    left: 10px;
    right: 10px;
    bottom: 100%;
    margin-bottom: 8px;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const FooterAlert = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    padding: 9px 16px;
    background-color: #fffbe6;
    border: 1px solid #ffe58f;
    border-radius: 2px;
    gap: 10px;
`;

export const AlertSpan = styled.span`
    font-size: 16px;
    color: #000000;
    font-weight: 400;
    margin: 0px;
`;
